import api from './api';

const templatesService = {
  // Get all templates with pagination and filters
  getTemplates: (params = {}) => {
    const { page = 1, limit = 10, sortBy = 'created_at', sortOrder = 'desc', status = 'all', search = '', isAll = 0 } = params;
    return api.get('/admin/templates', {
      params: {
        page,
        limit,
        sortBy,
        sortOrder,
        status,
        search,
        isAll,
      },
    });
  },

  // Get template by ID
  getTemplateById: (id) => api.get(`/admin/templates/${id}`),

  // Create new template
  createTemplate: (payload) => api.post('/admin/templates', payload),

  // Update template
  updateTemplate: (id, payload) => api.put(`/admin/templates/${id}`, payload),

  // Delete template
  deleteTemplate: (id) => api.delete(`/admin/templates/${id}`),

  // Bulk delete templates
  bulkDeleteTemplates: (ids) => api.delete('/admin/templates', { data: { ids } }),

  // Change template status
  changeStatus: (id) => api.delete(`/admin/templates/change-status/${id}`),
};

export default templatesService;
